module.exports = __webpack_public_path__ + "media/newstyle/images/Componente 6 – 2-a3efc3297580bcdcbdc03d64e297065e.svg";